export default __webpack_public_path__ + "static/media/sante1.89956752.jpg";